/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Phone_TitleInputs */

const en_hood_phone_title = /** @type {(inputs: Hood_Phone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Down to 320 px`)
};

/**
* | output |
* | --- |
* | "Down to 320 px" |
*
* @param {Hood_Phone_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_phone_title = /** @type {((inputs?: Hood_Phone_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Phone_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_phone_title(inputs)
});